<template>
  <div
    :class="[opened && !withoutDropdown ? '' : '', classes]"
    class="welcome-faq-item bg--color-01 sha--03 bor--radius-12"
  >
    <div @click="openPostHandler">
      <exc-block-heading-row
        size="l"
        no-wrap
        class="welcome-faq-item__toggler bor--radius-12"
      >
        <template #first>
          <p
            class="welcome-faq-item__title txt--22px txt--height-30px txt--bold txt--color-04 mb-0"
          >
            {{ post.title }}
          </p>
        </template>

        <template v-if="!withoutDropdown" #right>
          <span
            :class="{ 'welcome-faq-item__icon--opened': opened }"
            class="welcome-faq-item__icon"
          >
            <img :src="require('@/assets/icons/welcome/dropdown-arrow.svg')" width="37px" height="37px" loading="lazy" alt="faq">
            <!-- <dropdown-arrow /> -->
          </span>
        </template>
      </exc-block-heading-row>
    </div>

    <div v-show-slide="opened" class="welcome-faq-item__content">
      <div
        class="
          txt--color-03 txt--weight-500 txt--height-30px txt--22px mb-0
          pb-12 pb-24--l pt-8 pt-12--l
          pl-32--m pr-32--m pl-20 pr-20
        "
        v-html="post.content"
      />
    </div>
  </div>
</template>

<script>
import { ExcBlockHeadingRow } from '@/components/common'

export default {
  name: 'WelcomeFaqItem',
  components: {
    ExcBlockHeadingRow,
    DropdownArrow: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/icons/dropdown-arrow.svg?inline'
      ),
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    withoutDropdown: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      opened: false,
    }
  },
  computed: {
    classes () {
      return {
        'welcome-faq-item--opened': this.opened,
        'welcome-faq-item--dropdown': !this.withoutDropdown,
      }
    },
  },
  created () {
    if (this.withoutDropdown) this.opened = true
  },
  methods: {
    openPostHandler () {
      if (this.withoutDropdown) return
      this.opened = !this.opened
    },
  },
}
</script>

<style lang="scss" scoped>
.welcome-faq-item {
  $root: &;

  margin-bottom: toRem(18px);
  transition: 0.3s;

  &--dropdown:hover {
    #{$root}__toggler {
      cursor: pointer;
    }
  }

  ::v-deep .exc-block-heading-row__container {
    background: none;
    border: none;

    @include bp(375px, 768px) {
      padding: toRem(16px) toRem(20px);
    }
  }

  &__icon {
    transition: 0.3s;
    transform: rotate(0deg);

    &--opened {
      transform: rotate(180deg);
    }
  }

  &__content {
    ::v-deep img {
      max-width: 100%;
      height: auto;
    }

    ::v-deep p {
      margin: 0;
    }
  }
}
</style>
